import { Dialog } from '@mui/material';
import React from 'react';
import IntlMessages from 'Util/IntlMessages';
import BasicButton from 'Components/Button/BasicButton';

const BasicTextDialog = ({ open = false, onClose, onConfirm, titleId, subTitleId, closeId = 'button.close', confirmId }) => {
  return (
    <Dialog
      fullWidth={true}
      maxWidth='modalMini'
      open={open}
      disableScrollLock={false}
      disableEscapeKeyDown={false}
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '10px',
          padding: '0px',
        },
      }}
      slotProps={{
        backdrop: {
          style: {
            backgroundColor: 'var(--Background-Dim, rgba(0, 0, 0, 0.56))',
          },
          onClick: e => {
            e.stopPropagation();
            e.preventDefault();
          },
        },
      }}
    >
      <div className='basic-warning-dialog'>
        <div className='basic-warning-dialog-header'>
          <div className='basic-warning-dialog-header-content'>
            <div className='basic-warning-dialog-header-content-title'>{titleId && <IntlMessages id={titleId} />}</div>
            <div className='basic-warning-dialog-header-content-subtitle'>{subTitleId && <IntlMessages id={subTitleId} />}</div>
          </div>
        </div>
        <div className='basic-warning-dialog-footer cursor-pointer no-drag'>
          <div className='basic-warning-dialog-footer-close' onClick={onClose}>
            <BasicButton type='text' textId={closeId} style={{ width: '100%', height: '100%', borderRadius: '0px' }} />
          </div>
          <div className='basic-warning-dialog-footer-divider' />
          <div className='basic-warning-dialog-footer-confirm' onClick={onConfirm}>
            <BasicButton type='textAccent' textId={confirmId} style={{ width: '100%', height: '100%', borderRadius: '0px' }} />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default BasicTextDialog;
